import React, { useState, useEffect, useRef } from "react";
import Header from "../Header";
import Footer from "../Footer";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import $ from "jquery";
import "datatables.net-bs5";
import { format } from "date-fns";
import CustomDateRangePicker from "../common/CustomDateRangePicker";
import "rsuite/dist/rsuite.min.css";
import { API_URL, BASE_URL } from "../Config";
import config from "../common/Config";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';

const AmountDueCustomerList = () => {
  const [salesDates, setSalesDates] = useState([null, null]);
  const salesOrderRef = useRef(null);
  const accessToken = localStorage.getItem("accessToken");

  // Handle form submit, set date range and trigger getSalesOrderList immediately
  const handleSubmit = (e) => {
    e.preventDefault();
    const [startDate, endDate] = salesDates;
    let formattedStartDate = startDate ? format(startDate, "MM/dd/yyyy") : "";
    let formattedEndDate = endDate ? format(endDate, "MM/dd/yyyy") : "";
    getSalesOrderList(formattedStartDate, formattedEndDate);
  };

   const handleSendEmail = async (customerId) => {
    try {
      const apiUrl = `${config.API_URL}/send_due_email`;
      const formData = new FormData();
      formData.append("customer_id", customerId);

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (data.success) {
        Swal.fire("Success", "Email sent successfully!", "success");
      } else {
        Swal.fire("Error", "Failed to send email.", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Failed to send email.", "error");
    }
  };
  // Fetch sales order list from API
  const getSalesOrderList = (startDate, endDate) => {
    const $table = $(salesOrderRef.current);
    // Destroy any existing DataTable instance to reinitialize with new data
    if ($.fn.DataTable.isDataTable($table)) {
      $table.DataTable().destroy();
    }
    $table.DataTable({
      processing: true,
      serverSide: true,
      ajax: {
        url: `${config.API_URL}/get_amtDueCustomer`,
        type: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        data: function (d) {
          return $.extend({}, d, {
            draw: d.draw,
            start: d.start,
            length: d.length,
            searchByFromdate: startDate,
            searchByTodate: endDate,
            authorization: `Bearer ${accessToken}`,
          });
        },
        dataSrc: function (json) {
          return Array.isArray(json.data) ? json.data : [];
        },
      },
      language: {
        paginate: {
          first: "First",
          last: "Last",
          next: "Next",
          previous: "Previous",
        },
        search: "Search:",
      },
      columns: [
        {
          data: null,
          title: "Sr. No.",
          orderable: false,
          render: function (data, type, row, meta) {
            return meta.row + 1 + (meta.settings._iDisplayStart || 0);
          },
        },
        { data: "customer_name" },
        { data: "total_due", className: "text-end", width: "10%" },
        { data: "get_dues_zero_to_30", className: "text-end", width: "10%" },
        { data: "get_dues_30", className: "text-end", width: "10%" },
        { data: "get_dues_60", className: "text-end", width: "10%" },
        { data: "get_dues_90", className: "text-end", width: "10%" },
        {
          data: null,
          title: 'Action',
          render: function (data, type, row) {
            return `
              <div style="display: flex; align-items: center; gap: 10px;">
                <div class="action-popdot">
                  <a class="icon" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="bi bi-three-dots"></i>
                  </a>
                  <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow"> 
                    <li>
                      <a class="deductionbtn send-email-btn" data-customerid="${row.id}" title="Send Email">
                        <i class="bi bi-envelope"></i>Send Email
                      </a>
                    </li>      
                  </ul>
                </div>
              </div>`;
          }
        }
        ],
      order: [],
      pageLength: 50,
      drawCallback: function () {
        // Attach click handler for Send Email buttons
        $(".send-email-btn")
          .off("click")
          .on("click", function () {
            const customerId = $(this).data("customerid");
            handleSendEmail(customerId);
          });
      },
    });
  };

  // Export to Excel handler
  const handleExport = async () => {
    // Fetch all data from the server for export (bypass DataTables paging)
    try {
      const apiUrl = `${config.API_URL}/get_amtDueCustomer`;
      const formData = new FormData();
      formData.append('draw', 1);
      formData.append('start', 0);
      formData.append('length', 1000000); // Large number to get all records

      // Add date range if needed
      const [startDate, endDate] = salesDates;
      let formattedStartDate = startDate ? format(startDate, "MM/dd/yyyy") : "";
      let formattedEndDate = endDate ? format(endDate, "MM/dd/yyyy") : "";
      if (formattedStartDate) formData.append('searchByFromdate', formattedStartDate);
      if (formattedEndDate) formData.append('searchByTodate', formattedEndDate);

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });
      const result = await response.json();
      const allData = Array.isArray(result.data) ? result.data : [];

      const wsData = [
        [
          "Sr. No.",
          "Customer Name(Ac/No)",
          "account_no",
          "Amount Due",
          "0 to 30 Days",
          "30 + Days",
          "60 + Days",
          "90 + Days"
        ],
        ...allData.map((row, idx) => [
          idx + 1,
          row.customer_name,
          row.account_no,
          row.total_due,
          row.get_dues_zero_to_30,
          row.get_dues_30,
          row.get_dues_60,
          row.get_dues_90
        ])
      ];

      const ws = XLSX.utils.aoa_to_sheet(wsData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "AmountDueCustomers");
      XLSX.writeFile(wb, "AmountDueCustomers.xlsx");
    } catch (err) {
      Swal.fire("Error", "Failed to export all data.", "error");
    }
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    getSalesOrderList("", "");
    return () => {
      if (
        salesOrderRef.current &&
        $.fn.DataTable.isDataTable(salesOrderRef.current)
      ) {
        $(salesOrderRef.current).DataTable().destroy();
      }
    };
  }, []);

  return (
    <>
      <Header />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <a href={config.BASE_URL + "/Dashboard"}>
                <i className="fa fa-home"></i>
              </a>
              &nbsp;&gt;&nbsp;
              <a href={config.BASE_URL + "/account/payments"}>Account</a>
              &nbsp;&gt;&nbsp;
              <span className="last-crumb">Amount Due Customers </span>
            </div>
          </div>
        </div>
      </div>
      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <div>
                <div className="row">
                  <div className="col-md-12 col-lg-6 col-sm-12">
                    <CustomDateRangePicker
                      dates={salesDates}
                      onChange={setSalesDates}
                      onSubmit={handleSubmit}
                    />
                  </div>
                  <div className="col-md-12 col-lg-6 col-sm-12" style={{ textAlign: "right", marginTop: 10 }}>
                    <button className="btn btn-success btn-sm" onClick={handleExport}>
                      Export to Excel
                    </button>
                  </div>
                </div>
                <div className="">
                  <div className="col-md-12 col-lg-12 col-xs-12">
                    <div
                      className="verical-scrl-wrapper amount-due-customer-list-area"
                      id="style-3"
                    >
                      <table
                        className="table table-bordered dataTable resizable"
                        ref={salesOrderRef}
                      >
                        <thead>
                          <tr>
                            <th>Sr. No.</th>
                            <th>Customer Name(Ac/No)</th>
                            <th> Amount Due </th>
                            <th> 0 to 30 Days </th>
                            <th>30 + Days</th>
                            <th>60 + Days</th>
                            <th>90 + Days</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* DataTable will populate this dynamically */}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AmountDueCustomerList;
